/** @format */
import React from "react";
import { smallOriOS } from "../Utils";

const ButtonLinkLink = ({ href, buttonTitle, ...props }) => (
  <a className="spaceFloorPlanLink docButton bk-button" href={href} {...props}>
    {buttonTitle}
  </a>
);

const ButtonLinkButton = ({ onClick, buttonTitle, ...props }) => (
  <button
    className="spaceFloorPlanLink docButton bk-button"
    onClick={onClick}
    {...props}
  >
    {buttonTitle}
  </button>
);

const ButtonOrLinkOnMobile = ({
  buttonTitle,
  href,
  onClick,
}) => {
  if (smallOriOS(false)) {
    return <ButtonLinkLink href={href} buttonTitle={buttonTitle} />;
  } else {
    return <ButtonLinkButton onClick={onClick} buttonTitle={buttonTitle} />;
  }
};

export { ButtonLinkButton, ButtonOrLinkOnMobile };
